const BrandingStore = {
  logo_size: 45,
  logo_login_size: 220,
  series_colors: ["#00274C", "#2BBBB5", "#8D85B9", "#D87B58", "#83C5DD", "#405D79", "#60CCC7", "#A9A3CA", "#E29C82", "#A2D3E5"],
  kycUrl: '',
};

export default BrandingStore;
